module.exports = __webpack_public_path__ + "img/curtaincall.db24d590.png";